import { createFileRoute, Outlet } from "@tanstack/react-router"

/** Connectors: list + editor (`/studio/connectors`) and conversations (`/studio/connectors/$connectorId`). */
export const Route = createFileRoute("/_app/studio/connectors")({
  staticData: { titleKey: "nav.items.connectors" },
  component: Outlet,
})
